'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CLASS_VISIBLE = exports.RESET_FORM_SELECTOR = exports.LOGIN_FORM_SELECTOR = exports.RESET_PASSWORD_TOGGLE = exports.TEMPLATE_SELECTOR = undefined;

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TEMPLATE_SELECTOR = exports.TEMPLATE_SELECTOR = '[data-login-register]'; /*
                                                                              *  Login Register
                                                                              *    Basic scripts for the login-register template. 
                                                                              *
                                                                              *
                                                                              *  Version:
                                                                              *    1.0.0 - 2020/03/25
                                                                              */

var RESET_PASSWORD_TOGGLE = exports.RESET_PASSWORD_TOGGLE = '[data-reset-password-toggle]';
var LOGIN_FORM_SELECTOR = exports.LOGIN_FORM_SELECTOR = '[data-login-form]';
var RESET_FORM_SELECTOR = exports.RESET_FORM_SELECTOR = '[data-reset-password-form]';

var CLASS_VISIBLE = exports.CLASS_VISIBLE = 'is-visible';

var LoginRegister = function () {
  function LoginRegister(container) {
    var _this = this;

    (0, _classCallCheck3.default)(this, LoginRegister);

    this.container = container;

    this.loginForm = container.find(LOGIN_FORM_SELECTOR);
    this.resetForm = container.find(RESET_FORM_SELECTOR);
    this.forms = [this.loginForm, this.resetForm];

    container.on('click touchend', RESET_PASSWORD_TOGGLE, function (e) {
      return _this.onFormToggle(e);
    });

    this.onEmailNoFound();
  }

  (0, _createClass3.default)(LoginRegister, [{
    key: 'onEmailNoFound',
    value: function onEmailNoFound() {
      if (window.location.href.indexOf('#recover') !== -1) {
        this.forms.forEach(function (e) {
          return e.toggleClass(CLASS_VISIBLE);
        });
      }
    }
  }, {
    key: 'onFormToggle',
    value: function onFormToggle(e) {
      e.preventDefault();
      e.stopPropagation();

      this.forms.forEach(function (e) {
        return e.toggleClass(CLASS_VISIBLE);
      });
    }
  }]);
  return LoginRegister;
}();

//Initialize


(0, _jquery2.default)(document).ready((0, _jquery2.default)(TEMPLATE_SELECTOR).each(function (e, i) {
  return new LoginRegister((0, _jquery2.default)(i));
}));